import styled from "styled-components";
import { Colors } from "../../config";

export const Container = styled.div`
  display: flex;
  padding: 0 2rem;
  gap: 4rem;
  @media only screen and (max-width: 768px) {
    flex-direction: column;
    padding: 0;
    gap: 1rem;
  }
`;

export const LeftSection = styled.div`
  width: 45%;
  margin-top: 2.5rem;

  @media only screen and (max-width: 768px) {
    width: 100%;
    padding: 0 1rem;
    box-sizing: border-box;
  }
`;

export const RightSection = styled.div`
  position: relative;
  width: 55%;
  @media only screen and (max-width: 768px) {
    width: 100%;
  }
`;

export const DetailsContainer = styled.div`
  height: 68vh;
  overflow-y: scroll;
  overflow-x: hidden;
  @media only screen and (max-width: 768px) {
    overflow: auto;
    height: auto;
  }
`;

export const DisabledRightContainer = styled.div`
  background-color: ${Colors.whiteOpacity40};
  border-radius: 1rem;
  position: absolute;
  width:100%;
  height:calc(100% - 1rem);
  z-index:9;
  top:1rem;
`;

export const BookingContainer = styled.div`
  padding: 1.5rem 1.5rem;
  background-color: white;
  border-radius: 1rem;
  height: 80vh;
  margin-top: 1rem;
  overflow-y: scroll;
  overflow-x: hidden;
  background-image: url(${require("../../assets/images/biz_booking_bg.png")});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: bottom;
  @media only screen and (max-width: 768px) {
    padding: 1rem;
    height: auto;
    overflow: auto;
  }
`;

export const Title = styled.div`
  color: ${Colors.prussianBlue};
  font-weight: 700;
  font-size: 1.25rem;
  margin-bottom: 1.5rem;
`;
